
namespace TabAurous.Common {

    @Serenity.Decorators.registerClass()
    export class DesignEnquirySelectGrid extends _Ext.GridBase<OMS.DesignRow, any> {
        protected getColumnsKey() { return 'OMS.Design'; }
        protected getIdProperty() { return OMS.DesignRow.idProperty; }
        protected getLocalTextPrefix() { return OMS.DesignRow.localTextPrefix; }
        protected getService() { return OMS.DesignEnquiryService.baseUrl; }
        protected useViewMode() { return true; }
        items: any[];

        constructor(container: JQuery, options) {
            super(container, options);
            this.slickGrid.setOptions({ rowHeight: 30 });
            var designcode = options.GridFilters.DesignCode;
            (this.view.params as TransactionRequest).DesignCode = designcode ;

             
        }
        private autoSize;
          

        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
        updateInterface() {
            super.updateInterface();

            if (!this.hasInsertPermission || this.readOnly) {
                this.toolbar.findButton('add-button').toggle(this.updateDisabledState());
            }
        }
    }
}